export const FieldTypes = {
  phone: "phone_input",
  password: "password",
  number: "number",
  checkbox: "checkbox",
  select: "select",
  autocomplete: "autocomplete",
  date: "date",
  drag_and_drop: "drag_and_drop",
  file: "file",
  textarea: "textarea",
  text: "text",
  email: "email",
  datetime: "datetime"
}

